export type LegalAudience = 'all' | 'bidder' | 'owner';

export interface LegalSection {
  id: string;
  title: string;
  audience: LegalAudience;
  /** ย่อหน้า — บาง paragraph อาจมี bullet list (ใช้ `\n- ` ขึ้นต้น) */
  paragraphs: string[];
}

/** วันที่เผยแพร่เอกสารฉบับนี้ (ISO) — bump พร้อมกับ Legal:TermsVersion */
export const LEGAL_EFFECTIVE_DATE = '2026-05-08';
export const LEGAL_VERSION = '1.1';

// ═══════════════════════════════════════════════════════════════
// TERMS & CONDITIONS — ข้อกำหนดและเงื่อนไขการใช้บริการ
// ═══════════════════════════════════════════════════════════════

export const TERMS_SECTIONS: LegalSection[] = [
  {
    id: 'general',
    title: '1. ข้อกำหนดทั่วไปและการยอมรับ',
    audience: 'all',
    paragraphs: [
      'ยินดีต้อนรับสู่ e-Bidding ("แพลตฟอร์ม", "บริการ", "เรา") ซึ่งดำเนินการโดย บริษัท เอเวสต้า จำกัด สำนักงานใหญ่ตั้งอยู่เลขที่ 889 หมู่ 15 ตำบลคำใหญ่ อำเภอเมือง จังหวัดอุบลราชธานี 34000',
      'การเข้าถึงและใช้งานแพลตฟอร์มถือว่าท่านได้อ่าน ทำความเข้าใจ และยอมรับข้อกำหนดและเงื่อนไขฉบับนี้โดยผูกพันตามกฎหมาย หากท่านไม่ยอมรับข้อกำหนดใดข้อกำหนดหนึ่ง โปรดหยุดใช้งานแพลตฟอร์มทันที',
      'เราอาจปรับปรุงข้อกำหนดนี้เป็นระยะ — กรณีมีการเปลี่ยนแปลงที่เป็นสาระสำคัญ ระบบจะแสดงหน้าต่างให้ท่านยอมรับเวอร์ชันใหม่ก่อนใช้งานต่อไป',
    ],
  },
  {
    id: 'eligibility',
    title: '2. คุณสมบัติของผู้ใช้งาน',
    audience: 'all',
    paragraphs: [
      'ผู้ใช้งานที่เป็นบุคคลธรรมดาต้องมีอายุไม่ต่ำกว่า 20 ปีบริบูรณ์ และมีความสามารถในการทำนิติกรรมตามกฎหมายไทย',
      'ผู้ใช้งานที่เป็นนิติบุคคลต้องจดทะเบียนถูกต้องตามกฎหมายไทย และผู้ดำเนินการแทนต้องมีอำนาจลงนามผูกพันนิติบุคคลนั้น',
      'ผู้ใช้งานต้องไม่เคยถูกระงับหรือปิดบัญชีจากแพลตฟอร์มเนื่องจากการละเมิดข้อกำหนดมาก่อน',
    ],
  },
  {
    id: 'account',
    title: '3. การลงทะเบียนและการใช้งานบัญชี',
    audience: 'all',
    paragraphs: [
      'ท่านจะต้องให้ข้อมูลที่ถูกต้อง เป็นปัจจุบัน และครบถ้วนในการสมัครสมาชิก ทั้งชื่อ-นามสกุล เบอร์โทรศัพท์ อีเมล รวมถึงข้อมูลอื่นที่ระบบร้องขอ',
      'ท่านมีหน้าที่รักษาความลับของรหัสผ่านและไม่เปิดเผยให้ผู้อื่นทราบ การกระทำใด ๆ ที่เกิดขึ้นผ่านบัญชีของท่านถือว่าท่านเป็นผู้กระทำ',
      'การสร้างบัญชีซ้ำซ้อน การแอบอ้างเป็นบุคคลอื่น หรือการใช้ข้อมูลปลอม อาจเป็นเหตุให้บัญชีถูกระงับทันที',
    ],
  },
  {
    id: 'service-access',
    title: '4. การเข้าถึงบริการ',
    audience: 'all',
    paragraphs: [
      'เราพยายามรักษาความพร้อมใช้งานของแพลตฟอร์ม 24 ชั่วโมง แต่ไม่รับประกันว่าจะไม่มีการหยุดชะงัก ท่านตกลงว่าการหยุดชะงักชั่วคราวเพื่อซ่อมบำรุง ปรับปรุงระบบ หรือเหตุสุดวิสัย มิให้ถือเป็นการผิดสัญญา',
      'เราขอสงวนสิทธิ์ในการปฏิเสธการให้บริการ จำกัด หรือยุติการเข้าถึงของผู้ใช้งานใดก็ได้ หากพิจารณาแล้วเห็นว่ามีพฤติกรรมที่ขัดต่อข้อกำหนดหรือกฎหมาย',
    ],
  },
  {
    id: 'ip',
    title: '5. ทรัพย์สินทางปัญญา',
    audience: 'all',
    paragraphs: [
      'เนื้อหาทั้งหมดบนแพลตฟอร์ม ไม่ว่าจะเป็นข้อความ รูปภาพ โลโก้ ซอฟต์แวร์ หรือโครงสร้างการออกแบบ เป็นลิขสิทธิ์ของเราหรือผู้ให้สิทธิ์ที่เกี่ยวข้อง',
      'ห้ามทำซ้ำ ดัดแปลง เผยแพร่ หรือใช้ประโยชน์เชิงพาณิชย์โดยไม่ได้รับอนุญาตเป็นลายลักษณ์อักษร',
      'เนื้อหาที่ผู้ใช้งานอัปโหลด (เช่น รูปสินค้า คำอธิบายประมูล) ยังคงเป็นกรรมสิทธิ์ของท่าน แต่ท่านอนุญาตให้เรานำไปใช้เพื่อการให้บริการ การโปรโมต และการบันทึกสถิติได้',
    ],
  },
  {
    id: 'acceptable-use',
    title: '6. การใช้งานอย่างเหมาะสม',
    audience: 'all',
    paragraphs: [
      'ห้ามใช้แพลตฟอร์มเพื่อวัตถุประสงค์ที่ผิดกฎหมาย ฉ้อโกง ฟอกเงิน หรือละเมิดสิทธิของบุคคลอื่น',
      'ห้ามอัปโหลดไวรัส มัลแวร์ หรือข้อมูลที่อาจก่อให้เกิดความเสียหายต่อระบบ',
      'ห้ามสแปม ส่งข้อความรบกวน หรือใช้ระบบอัตโนมัติที่ไม่ได้รับอนุญาต (bot/scraper) เพื่อดึงข้อมูล',
      'ห้ามปลอมแปลงการประมูล การปั่นราคา หรือการสมคบเพื่อให้ได้เปรียบอย่างไม่เป็นธรรม',
    ],
  },
  {
    id: 'third-party',
    title: '7. เว็บไซต์บุคคลที่สาม',
    audience: 'all',
    paragraphs: [
      'แพลตฟอร์มอาจมีลิงก์ไปยังเว็บไซต์ของบุคคลที่สาม เช่น ระบบชำระเงิน หรือระบบยืนยันตัวตน — เว็บไซต์เหล่านี้อยู่นอกการควบคุมของเรา',
      'เราไม่รับผิดชอบต่อเนื้อหา นโยบายความเป็นส่วนตัว หรือการให้บริการของบุคคลที่สาม ท่านควรอ่านข้อกำหนดของเว็บไซต์เหล่านั้นก่อนใช้งาน',
    ],
  },
  // ── Bidder sections ─────────────────────────────────────────
  {
    id: 'bidding',
    title: '8. การเข้าร่วมประมูล',
    audience: 'bidder',
    paragraphs: [
      'ผู้ประมูลต้องยืนยันตัวตน (KYC) ก่อนเข้าร่วมการประมูลบางประเภทตามที่แต่ละเจ้าของร้านกำหนด',
      'การเสนอราคา (bid) ทุกครั้งถือเป็นข้อเสนอที่ผูกพันท่านตามกฎหมาย — ท่านไม่สามารถถอนการเสนอราคาได้หลังจากที่ระบบยืนยันการรับข้อเสนอเรียบร้อยแล้ว เว้นแต่เจ้าของร้านค้าจะยินยอม',
      'กรณีท่านเป็นผู้ชนะ ท่านต้องดำเนินการชำระเงินตามเงื่อนไขและระยะเวลาที่แต่ละประกาศประมูลกำหนด หากไม่ปฏิบัติตาม อาจถูกระงับการใช้งานและมีผลต่อเครดิตในอนาคต',
    ],
  },
  {
    id: 'bidder-qualify',
    title: '9. คุณสมบัติและการอนุมัติเข้าร่วมประมูล',
    audience: 'bidder',
    paragraphs: [
      'การประมูลบางประเภทอาจกำหนดให้ผู้ประมูลส่งเอกสารคุณสมบัติ (qualification) ให้เจ้าของร้านพิจารณาก่อนเข้าร่วม — เจ้าของร้านมีสิทธิ์อนุมัติหรือปฏิเสธตามดุลยพินิจ',
      'แพลตฟอร์มไม่ได้เรียกเก็บเงินมัดจำหรือหลักประกันใดๆ จากผู้ประมูลก่อนการเสนอราคา — เงื่อนไขทางการเงินระหว่างผู้ประมูลกับเจ้าของร้านเป็นข้อตกลงนอกระบบ',
    ],
  },
  {
    id: 'bidder-after-win',
    title: '10. หลังเป็นผู้ชนะการประมูลและช่องทางอุทธรณ์',
    audience: 'bidder',
    paragraphs: [
      'การชำระเงิน การส่งมอบ และเงื่อนไขอื่นๆ หลังประกาศผู้ชนะ เป็นไปตามที่เจ้าของร้านกำหนดในแต่ละประกาศ — แพลตฟอร์มไม่ได้เป็นคู่สัญญาในธุรกรรมดังกล่าว',
      'หากท่านไม่เห็นด้วยกับผลการประมูล ท่านสามารถยื่นอุทธรณ์ผ่านระบบได้ภายในระยะเวลาที่แต่ละประกาศกำหนด — ระบบจะบันทึก log ครบถ้วนและให้เจ้าของร้านพิจารณา',
    ],
  },
  // ── Owner sections ──────────────────────────────────────────
  {
    id: 'owner-register',
    title: '11. การสมัครเป็นเจ้าของร้านค้าและการยืนยันตัวตน (KYC)',
    audience: 'owner',
    paragraphs: [
      'เจ้าของร้านค้าสามารถใช้งานทุกฟังก์ชันหลักของระบบได้ทันทีโดยไม่ต้องรอการยืนยันตัวตน (KYC) — เพื่อให้ทดลองระบบได้อย่างครบถ้วนก่อนตัดสินใจ',
      'ข้อจำกัดเดียวที่ผูกกับ KYC คือ การตั้งสถานะร้านเป็น "สาธารณะ (Public)" — กรณีร้านที่ยังไม่ได้รับการยืนยัน จะใช้ได้แค่สถานะส่วนตัว (Private) หรือปิดร้าน (Closed) เท่านั้น',
      'ร้านที่ผ่านการยืนยันตัวตนแล้วจะได้รับ verified badge สีเขียวข้างชื่อร้านในทุกหน้า เพื่อสร้างความเชื่อมั่นให้ผู้ประมูล',
      'การยืนยันตัวตนทำได้โดยส่งเอกสารและข้อมูลตามที่ระบบกำหนด — ทั้งกรณีบุคคลธรรมดา (เลขบัตรประชาชน, วันเกิด, ที่อยู่ตามบัตร) และนิติบุคคล (เลขทะเบียนนิติบุคคล, TIN, ชื่อกรรมการผู้มีอำนาจ, เอกสารประกอบ)',
      'การให้ข้อมูล KYC ที่เป็นเท็จหรือแอบอ้าง ถือเป็นความผิดร้ายแรงและอาจนำไปสู่การปิดบัญชี พร้อมดำเนินคดีตามกฎหมาย',
    ],
  },
  {
    id: 'owner-package',
    title: '12. แพคเกจและการสร้างประกาศประมูล',
    audience: 'owner',
    paragraphs: [
      'การสร้างประกาศประมูล (auction) จำเป็นต้องมีแพคเกจที่ active อยู่ — ระบบจะตรวจสอบวันหมดอายุของแพคเกจก่อนอนุญาตให้สร้างทุกครั้ง',
      'ผู้ใช้งานใหม่สามารถเคลม "แพคเกจทดลองใช้งานฟรี" ได้ครั้งเดียวต่อบัญชี — เมื่อเคลมแล้วจะสามารถสร้างประกาศได้ทันทีตามเงื่อนไขของแพคเกจฟรีนั้น',
      'หลังจากแพคเกจหมดอายุ ท่านจะไม่สามารถสร้างประกาศใหม่ได้จนกว่าจะต่ออายุหรือซื้อแพคเกจใหม่ — ประกาศที่สร้างไว้ก่อนหน้าจะยังคงดำเนินการต่อตามปกติ',
      'การซื้อแพคเกจถือเป็นธุรกรรมขั้นสุดท้าย — ไม่สามารถขอคืนเงินได้ เว้นแต่กรณีระบบผิดพลาดและยังไม่ได้ใช้งาน (ภายใน 7 วันนับจากวันซื้อ)',
      'เราสงวนสิทธิ์ในการปรับปรุงราคาและรายละเอียดแพคเกจ โดยจะไม่มีผลย้อนหลังกับแพคเกจที่ท่านซื้อไปก่อนแล้ว',
    ],
  },
  {
    id: 'owner-responsibility',
    title: '13. ความรับผิดชอบของเจ้าของร้านค้า',
    audience: 'owner',
    paragraphs: [
      'เจ้าของร้านค้ามีหน้าที่รับผิดชอบต่อข้อมูลประกาศ คุณภาพสินค้า/บริการ และการส่งมอบตามที่ระบุไว้ในประกาศประมูล',
      'ต้องส่งมอบสินค้า/บริการให้ผู้ชนะประมูลภายในระยะเวลาที่กำหนด หากเกิดเหตุสุดวิสัย ต้องแจ้งผู้ประมูลและแพลตฟอร์มโดยไม่ชักช้า',
      'กรณีสินค้าไม่ตรงตามที่ประกาศ เจ้าของร้านค้าอาจถูกเรียกคืนเงินและรับผิดตามกฎหมายคุ้มครองผู้บริโภค',
      'เจ้าของร้านค้าไม่สามารถใช้แพลตฟอร์มในการขายสินค้าผิดกฎหมาย สินค้าลอกเลียนแบบ หรือสินค้าต้องห้ามตามกฎหมายไทย',
    ],
  },
  {
    id: 'owner-store-status',
    title: '14. การเปิด/ปิดสถานะร้านค้า',
    audience: 'owner',
    paragraphs: [
      'ร้านค้าสามารถเลือกสถานะได้ 3 ระดับ: สาธารณะ (public), ส่วนตัว (private), ปิดร้าน (closed) — สถานะ Private และ Closed สามารถเปลี่ยนได้ทันทีโดยไม่ต้องรอการยืนยัน KYC',
      'การตั้งสถานะร้านเป็น "สาธารณะ (Public)" จะทำได้ก็ต่อเมื่อ KYC ของร้านได้รับการยืนยันจากทีมงานเรียบร้อยแล้วเท่านั้น',
      'ระบบอาจบังคับปิดร้าน (force close) กรณีพบการละเมิดข้อกำหนด หรือได้รับคำสั่งจากหน่วยงานราชการที่มีอำนาจตามกฎหมาย',
    ],
  },
  // ── Common shared ───────────────────────────────────────────
  {
    id: 'suspension',
    title: '15. การระงับและการปิดบัญชี',
    audience: 'all',
    paragraphs: [
      'เราขอสงวนสิทธิ์ในการระงับหรือปิดบัญชีของท่านทันทีโดยไม่ต้องแจ้งล่วงหน้า หากพบว่าท่านละเมิดข้อกำหนด ฉ้อโกง หรือมีพฤติกรรมที่สร้างความเสียหายต่อผู้ใช้งานอื่น',
      'ท่านสามารถขอปิดบัญชีได้ด้วยตนเองผ่านการติดต่อทีมสนับสนุนลูกค้า — ข้อมูลบางส่วนอาจยังคงถูกเก็บไว้ตามที่กฎหมายกำหนด (ดูรายละเอียดในนโยบายความเป็นส่วนตัว)',
    ],
  },
  {
    id: 'liability',
    title: '16. การจำกัดความรับผิด',
    audience: 'all',
    paragraphs: [
      'แพลตฟอร์มเป็นเพียงตัวกลางในการจับคู่ระหว่างเจ้าของร้านค้ากับผู้ประมูล เราไม่ได้เป็นคู่สัญญาในธุรกรรมการซื้อขายระหว่างผู้ใช้งาน',
      'เราไม่รับผิดต่อความเสียหายโดยอ้อม ความเสียหายที่เกิดจากการพลาดโอกาสทางธุรกิจ หรือความเสียหายที่ไม่สามารถคาดการณ์ได้',
      'ความรับผิดรวมของเรา (ถ้ามี) จะไม่เกินจำนวนที่ท่านได้ชำระให้แก่แพลตฟอร์มภายใน 12 เดือนก่อนเกิดเหตุ',
    ],
  },
  {
    id: 'governing-law',
    title: '17. กฎหมายที่ใช้บังคับและเขตอำนาจศาล',
    audience: 'all',
    paragraphs: [
      'ข้อกำหนดฉบับนี้อยู่ภายใต้กฎหมายแห่งราชอาณาจักรไทย',
      'ข้อพิพาทใดๆ ที่เกิดขึ้นจากหรือเกี่ยวข้องกับข้อกำหนดนี้ ให้อยู่ในเขตอำนาจของศาลไทย',
    ],
  },
  {
    id: 'contact',
    title: '18. ช่องทางติดต่อ',
    audience: 'all',
    paragraphs: [
      'กรณีมีข้อสงสัย ข้อร้องเรียน หรือต้องการแจ้งปัญหาเกี่ยวกับข้อกำหนดนี้ กรุณาติดต่อเราที่:',
      'บริษัท เอเวสต้า จำกัด\n- ที่อยู่: 889 หมู่ 15 ตำบลคำใหญ่ อำเภอเมือง จังหวัดอุบลราชธานี 34000\n- โทรศัพท์: +66(0)45-959-612\n- อีเมล: sales@avesta.co.th',
    ],
  },
];

// ═══════════════════════════════════════════════════════════════
// PRIVACY POLICY — นโยบายความเป็นส่วนตัว
// ═══════════════════════════════════════════════════════════════

export const PRIVACY_SECTIONS: LegalSection[] = [
  {
    id: 'scope',
    title: '1. ขอบเขตและนิยาม',
    audience: 'all',
    paragraphs: [
      'นโยบายความเป็นส่วนตัวฉบับนี้ใช้กับการเก็บรวบรวม การใช้ การเปิดเผย และการประมวลผลข้อมูลส่วนบุคคลของผู้ใช้งานแพลตฟอร์ม e-Bidding ทุกคน',
      '"ข้อมูลส่วนบุคคล" หมายถึงข้อมูลใด ๆ ที่สามารถระบุตัวบุคคลธรรมดาได้ ไม่ว่าโดยตรงหรือโดยอ้อม ตามพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 (PDPA)',
      'เราปฏิบัติตามกฎหมาย PDPA และมาตรฐานความปลอดภัยที่ยอมรับในระดับสากล',
    ],
  },
  {
    id: 'data-collected',
    title: '2. ข้อมูลส่วนบุคคลที่เก็บรวบรวม',
    audience: 'all',
    paragraphs: [
      'ข้อมูลที่เก็บเป็นมาตรฐานทั่วไป:\n- ชื่อ-นามสกุล / ชื่อบริษัท\n- อีเมล เบอร์โทรศัพท์ ที่อยู่\n- รูปภาพโปรไฟล์ (ถ้ามี)\n- ข้อมูลการใช้งาน (IP address, device ID, cookie, log)',
      'ข้อมูลการทำธุรกรรม:\n- ประวัติการเสนอราคา (bid history)\n- ประวัติการซื้อขาย\n- ใบแจ้งหนี้และการชำระเงิน',
    ],
  },
  {
    id: 'data-bidder',
    title: '2.1 ข้อมูลเพิ่มเติม — ผู้ประมูล',
    audience: 'bidder',
    paragraphs: [
      'ข้อมูลคุณสมบัติ (qualification) และเอกสารประกอบที่ส่งให้เจ้าของร้านพิจารณา ตามที่แต่ละประกาศประมูลกำหนด',
      'ประวัติการเสนอราคา (bid history) ของทุกประกาศที่ท่านเข้าร่วม',
      'บทสนทนา (chat) ระหว่างท่านกับเจ้าของร้านในแต่ละประกาศ',
      'คำอุทธรณ์และเอกสารประกอบที่ท่านส่งผ่านระบบ (ถ้ามี)',
    ],
  },
  {
    id: 'data-owner',
    title: '2.2 ข้อมูลเพิ่มเติม — เจ้าของร้านค้า',
    audience: 'owner',
    paragraphs: [
      'ข้อมูล KYC:\n- บุคคลธรรมดา: เลขบัตรประชาชน (เข้ารหัส), วันเกิด, ที่อยู่ตามบัตร\n- นิติบุคคล: เลขทะเบียนนิติบุคคล, เลขประจำตัวผู้เสียภาษี (TIN) (เข้ารหัสทั้งคู่), ชื่อกรรมการผู้มีอำนาจ',
      'เอกสารประกอบ KYC (รูปบัตร, หนังสือรับรอง, ภ.พ.20, หนังสือมอบอำนาจ) — จะถูกทำ watermark และจัดเก็บอย่างปลอดภัย',
      'ข้อมูลประกาศประมูล รูปสินค้า และประวัติคำสั่งซื้อที่เกิดขึ้นในร้าน',
    ],
  },
  {
    id: 'sources',
    title: '3. แหล่งที่มาของข้อมูล',
    audience: 'all',
    paragraphs: [
      'โดยตรงจากท่าน: ผ่านฟอร์มสมัครสมาชิก, การตั้งค่าบัญชี, การทำธุรกรรม',
      'จากระบบอัตโนมัติ: cookie, log การใช้งาน, analytics',
      'จากบุคคลที่สาม: ผู้ให้บริการชำระเงิน ผู้ให้บริการอีเมล (SMTP) ฯลฯ — ตามที่ท่านยินยอม',
    ],
  },
  {
    id: 'purposes',
    title: '4. วัตถุประสงค์ในการใช้ข้อมูล',
    audience: 'all',
    paragraphs: [
      'เพื่อการปฏิบัติตามสัญญาและการให้บริการ (ไม่ต้องขอความยินยอม):\n- สร้างและจัดการบัญชี\n- ดำเนินการประมูลและการชำระเงิน\n- ยืนยันตัวตนและตรวจสอบการฟอกเงิน (AML)\n- ออกใบแจ้งหนี้/ใบกำกับภาษี',
      'เพื่อการปฏิบัติตามกฎหมาย:\n- การเก็บบันทึกตามกฎหมายภาษี/บัญชี/AML\n- การตอบสนองต่อคำสั่งศาลหรือหน่วยงานราชการ',
      'เพื่อการพัฒนาบริการ (ต้องขอความยินยอม):\n- การวิเคราะห์พฤติกรรมผู้ใช้\n- การส่งข่าวสารการตลาด\n- การปรับปรุงฟีเจอร์ของระบบ',
    ],
  },
  {
    id: 'retention',
    title: '5. ระยะเวลาการเก็บข้อมูล',
    audience: 'all',
    paragraphs: [
      'ตลอดระยะเวลาที่ท่านเป็นสมาชิกของแพลตฟอร์ม',
      'หลังปิดบัญชี: เก็บต่อไปอีก 5-10 ปี ตามกฎหมายภาษีและ AML ที่เกี่ยวข้อง',
      'ข้อมูลที่ไม่จำเป็นตามกฎหมาย จะถูกลบหรือทำให้ระบุตัวไม่ได้เมื่อพ้นกำหนด',
    ],
  },
  {
    id: 'disclosure',
    title: '6. การเปิดเผยข้อมูลแก่บุคคลที่สาม',
    audience: 'all',
    paragraphs: [
      'เราจะเปิดเผยข้อมูลต่อบุคคลที่สามเฉพาะในกรณีต่อไปนี้:\n- เมื่อได้รับความยินยอมจากท่าน\n- เมื่อมีความจำเป็นต้องปฏิบัติตามสัญญา (เช่น ผู้ให้บริการชำระเงิน ผู้ให้บริการยืนยันตัวตน)\n- เมื่อมีหน้าที่ตามกฎหมาย (เช่น คำสั่งศาล กรมสรรพากร ปปง.)\n- เพื่อปกป้องสิทธิและความปลอดภัยของผู้ใช้งานหรือบุคคลอื่น',
      'เราจะไม่ขาย หรือให้เช่าข้อมูลส่วนบุคคลของท่านแก่บุคคลที่สามเพื่อวัตถุประสงค์ทางการตลาดโดยเด็ดขาด',
    ],
  },
  {
    id: 'cookies',
    title: '7. Cookies และเทคโนโลยีติดตาม',
    audience: 'all',
    paragraphs: [
      'แพลตฟอร์มใช้ cookies เพื่อจดจำสถานะการเข้าสู่ระบบ การตั้งค่าภาษา/ธีม และปรับปรุงประสบการณ์การใช้งาน',
      'ท่านสามารถปฏิเสธหรือลบ cookies ผ่านการตั้งค่าของเบราว์เซอร์ แต่อาจทำให้ฟังก์ชันบางอย่างไม่ทำงาน',
    ],
  },
  {
    id: 'rights',
    title: '8. สิทธิของเจ้าของข้อมูลส่วนบุคคล',
    audience: 'all',
    paragraphs: [
      'ตามกฎหมาย PDPA ท่านมีสิทธิดังต่อไปนี้:\n- สิทธิในการเข้าถึงข้อมูลและขอสำเนา\n- สิทธิในการขอแก้ไขข้อมูลให้ถูกต้อง\n- สิทธิในการขอให้ลบหรือทำลายข้อมูล\n- สิทธิในการขอให้ระงับการใช้ข้อมูล\n- สิทธิในการคัดค้านการประมวลผล\n- สิทธิในการขอให้ถ่ายโอนข้อมูล\n- สิทธิในการถอนความยินยอม\n- สิทธิในการร้องเรียนต่อคณะกรรมการคุ้มครองข้อมูลส่วนบุคคล',
      'การใช้สิทธิข้างต้นทำได้ผ่านช่องทางติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO) ด้านล่าง — เราจะดำเนินการภายใน 30 วัน',
    ],
  },
  {
    id: 'withdraw',
    title: '9. ผลของการถอนความยินยอม',
    audience: 'all',
    paragraphs: [
      'ท่านสามารถถอนความยินยอมได้ตลอดเวลา — อย่างไรก็ตาม การถอนความยินยอมอาจทำให้เราไม่สามารถให้บริการบางส่วนแก่ท่านได้',
      'การถอนความยินยอมไม่กระทบการประมวลผลที่ชอบด้วยกฎหมายก่อนการถอน',
    ],
  },
  {
    id: 'security',
    title: '10. มาตรการรักษาความปลอดภัย',
    audience: 'all',
    paragraphs: [
      'เราใช้มาตรการทางเทคนิคและบริหาร เช่น การเข้ารหัสข้อมูลสำคัญ (AES-256), การทำ watermark เอกสาร KYC, การควบคุมสิทธิ์การเข้าถึง และ HTTPS',
      'ถึงแม้จะมีมาตรการรักษาความปลอดภัยที่เหมาะสม เราไม่สามารถรับประกันได้ว่าจะปลอดภัย 100% จากการโจมตีทางไซเบอร์ — กรณีเกิดเหตุข้อมูลรั่วไหล เราจะแจ้งต่อสำนักงานคณะกรรมการคุ้มครองข้อมูลส่วนบุคคลและท่านภายใน 72 ชั่วโมงตามที่กฎหมายกำหนด',
    ],
  },
  {
    id: 'dpo',
    title: '11. ช่องทางติดต่อเจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล (DPO)',
    audience: 'all',
    paragraphs: [
      'บริษัท เอเวสต้า จำกัด — เจ้าหน้าที่คุ้มครองข้อมูลส่วนบุคคล\n- ที่อยู่: 889 หมู่ 15 ตำบลคำใหญ่ อำเภอเมือง จังหวัดอุบลราชธานี 34000\n- โทรศัพท์: +66(0)45-959-612\n- อีเมล: sales@avesta.co.th',
    ],
  },
  {
    id: 'law',
    title: '12. กฎหมายที่ใช้บังคับ',
    audience: 'all',
    paragraphs: [
      'นโยบายฉบับนี้อยู่ภายใต้พระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 และกฎหมายอื่นที่เกี่ยวข้องของประเทศไทย',
    ],
  },
];
